import { commitMutation, graphql } from "react-relay";
import environment from "../Network";
const mutation = graphql`
  mutation VerifyTokenMutation($token: String!) {
    verifyToken(token: $token) {
      payload
    }
  }
`;

export default (token, callback) => {
  const variables = {
    token,
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response) => {
      callback(!!response.verifyToken);
    },
    onError: (err) => console.error(err),
  });
};



// WEBPACK FOOTER //
// ./src/mutations/VerifyTokenMutation.js